<template>
	<div class="DownloadChapterCover">
		<div class="DownloadChapterWrap">
			<h2>付款</h2>
			<!-- 详情 -->
			<div class="totalDetail">
				<!-- 购买详情 -->
				<h3>购买详情</h3>
				<!-- 章节购买 -->
				<ul v-if="downloadWay == 0">
					<li class="nodeWrap">
						<span class="nodeText" :title="goods.name">{{goods.name}}</span>
						<span>{{'￥'+goods.price}}</span>
					</li>
				</ul>
				<!-- 全书购买 -->
				<div class="allbook" v-else>
					<img :src="goods.imagePath" alt="" />
					<div class="bookInfo">
						<h4 :title="goods.name">{{goods.name}}</h4>
						<p>全书购买</p>
						<span>{{'￥'+goods.price}}</span>
					</div>
				</div>
				<!-- 提示文字 -->
				<p v-if="sellWayText == -1">* 您选择试读的文章无法单独加入书单，所以将选择其所在章（书）加入。</p>
				<!-- 合计 -->
				<div class="total">
					<p class="text">合计</p>
					<p class="Price"><span>￥</span><span>{{ goods.actualPrice }}</span><span v-if="goods.deduction">{{ `(已购章节抵扣${goods.deduction}元)` }}</span></p>
				</div>
			</div>
			<!-- 支付方式 -->
			<h3>选择支付方式</h3>
			<div class="AilpayWayWrap">
				<div class="Ailpay" :class="AilpayWay==1?'SelectLight':''" v-if="!disabledAilpay">
					<el-radio v-model="AilpayWay" :label="1">支付宝支付</el-radio>
				</div>
				<div class="wechat" :class="AilpayWay==2?'SelectLight':''">
					<el-radio v-model="AilpayWay" :label="2">微信支付</el-radio>
				</div>
			</div>
			<!-- 确认支付 -->
			<p class="confirmBtn canConfirmBtn" v-if="isSubmit" @click="ConfirmPay">确认支付</p>
			<p class="confirmBtn notConfirmBtn" v-else>确认支付</p>
			<span @click="CloseDownload"></span>
		</div>
	</div>
</template>

<script>
import common from '../assets/js/common.js'
export default{
	data(){
		return{
			AilpayWay:1,  // 支付方式 1：支付宝 2：微信
			InformationId:undefined,  // 情报id
			disabledAilpay:false,  // 是否禁用支付宝支付
			payParams:undefined,
			payId:undefined,
			isSubmit: true
		}
	},
	props:{
		// 购买详情得到渲染方式 0:章节 1:整书
		downloadWay:{
			type:Number,
			default:1
		},
		// 章节id
		chapterId:{
			type:Number,
			default:undefined
		},
		// 是否为-1  为-1则显示提示文字
		sellWayText:{
			type:Number,
			default:undefined
		},
		// 商品
		goods:{
			type:Object,
			default: ()=> {
				return {}
			}
		},
		iID:{
			type:Number,
			default:undefined
		},
	},
	mounted() {
		this.InformationId = this.$route.query.InformationId ? this.$route.query.InformationId : this.iID;
		// let code = this.GetQueryString('code'); // 获取微信授权码
		this.JugeWx();
	},
	methods:{
		// 确认支付
		ConfirmPay(){
			this.isSubmit = false;
			if(!this.disabledAilpay || this.goods.price === 0){
				this.PcPayWay();
				this.CloseDownload();
				return;
			}
			this.WeChatFn();
		},
		// 微信浏览器
		WeChatFn(){
			let code = this.GetQueryString('code'); // 获取微信授权码
			code = code ? code : ''; // code为undefined传空字符串
			let url = Const_Api_Root + "/wx_redirect.html";
			let params = {
				"code": code, // 授权码
				"redirectUrl": encodeURIComponent(url), // 授权后重定向的页面
				"state":encodeURIComponent(location.hash),
				"paymentWay": "微信",
				"goodsId":  this.goods.id, // 商品号
				"quantity": 1 ,// 数量
				"SucceededUrl":Const_Api_Root+"/index.html#/paySuccess",
				"FailedUrl":Const_Api_Root+"/index.html#/payError"
			};
			this.$post('/api/payment',params)
			.then((res)=>{
				// 授权地址不为空跳转到授权页面
				if (!code && res.data.authorizationUrl) {
				    location.href = res.data.authorizationUrl;
				    return;
				}
				this.payParams = res.data.jsApiParameters; // 得到jsapi的参数
				this.payId = res.data.orderInfoId; // 生成的订单号
				this.CallPay();  // 调起微信浏览器支付
			}).catch((err)=>{
				throw err;
			});

		},
		// pc支付方式
		PcPayWay(){
			let params = this.SetParams();
			this.$post('/api/payment',params)
			.then((res)=>{
				sessionStorage.setItem('informationId',this.InformationId);
				sessionStorage.setItem('informationContentId',this.chapterId);
				
				if(this.goods.price === 0){
					location.href = Const_Api_Root+"/index.html#/paySuccess?orderInfoId="+res.data.orderInfoId + '&informationId=' + this.InformationId;
					return;
				}
				if(res.data.generated){
					if(res.data.form){
						document.write(res.data.form);
						return;
					}
					location.href = res.data.payUrl;
				}else{
					this.$message.error(res.data.message);
				}
			}).catch((err)=>{
				throw err;
			});
		},
		// 参数
		SetParams(){
			let way = this.AilpayWay == 1?'支付宝':'微信';
			return{
				"Quantity": 1,
				"PaymentWay": way,
				"GoodsId": this.goods.id,
				"SucceededUrl":Const_Api_Root+"/index.html#/paySuccess",
			    "FailedUrl":Const_Api_Root+"/index.html#/payError"
			};
			// "CouponId": "88afdff4-a6fb-4ae7-ah9b-5f51e162078e",  优惠券id(暂无该功能)
		},
		// 微信浏览器支付后fn
		WxPayFn(type){
			sessionStorage.setItem('informationId',this.InformationId);
			if(type){
				sessionStorage.setItem('informationContentId',this.chapterId);
				location.href = Const_Api_Root+"/index.html#/paySuccess?orderInfoId=" + this.payId + '&informationId=' + this.InformationId;
			}else{
				location.href = Const_Api_Root+"/index.html#/payError?informationId=" + this.InformationId;
			}
		},
		//调用微信JS api 支付
		JsApiCall() {
		    WeixinJSBridge.invoke(
		        'getBrandWCPayRequest',
		        JSON.parse(this.payParams), //json串
		        (res)=> { // 支付回调
		            // get_brand_wcpay_request:ok	支付成功
		            // get_brand_wcpay_request: cancel	支付过程中用户取消
		            // get_brand_wcpay_request: fail	支付失败
		            switch (res.err_msg) {
		                case 'get_brand_wcpay_request:ok':
							this.WxPayFn(true);
		                    break;
		                case 'get_brand_wcpay_request:cancel':
		                    this.WxPayFn(false);
		                    break;
		                case 'get_brand_wcpay_request:fail':
		                    this.WxPayFn(false);
		                    break;
		                default:
		                    this.WxPayFn(false);
		                    break;
		            }
		        }
		    );
		},
		CallPay() {
		    if (typeof WeixinJSBridge == "undefined") {
		        if (document.addEventListener) {
		            document.addEventListener('WeixinJSBridgeReady', this.JsApiCall, false);
		        } else if (document.attachEvent) {
		            document.attachEvent('WeixinJSBridgeReady', this.JsApiCall);
		            document.attachEvent('onWeixinJSBridgeReady', this.JsApiCall);
		        }
		    } else {
		        this.JsApiCall();
		    }
		},
		GetQueryString(name) {
			var result = location.href.match(new RegExp("[\?\&]" + name+ "=([^\&]+)","i"));
			if(result == null || result.length < 1){
				return "";
			}
			return result[1];
		},
		// 判断是否是微信浏览器
		JugeWx(){
			var ua = navigator.userAgent.toLowerCase();
			if(ua.match(/MicroMessenger/i)=="micromessenger") {
				this.AilpayWay = 2;
				this.disabledAilpay = true;
			} else {
				this.AilpayWay = 1;
			}
		},
		// 关闭章节购买
		CloseDownload(){
			common.$emit('closeChapter');
		},
		// 返回
		CommentReturn(){
			this.$router.go(-1);
		}
	}
}
</script>

<style scoped>
@media screen and (min-width: 320px) and (max-width: 1024px) {
	/* 订单信息 */
	.DownloadChapterWrap{
		width: 100%;
		background: #F7F8FA;
		padding: .5rem .25rem;
	}
	.DownloadChapterWrap h2{
		display: none;
	}
	.DownloadChapterWrap h3{
		font-size: 14px;
		color: #919095;
		letter-spacing: 0.6px;
		line-height: 14px;
		margin: 20px 0 12px;
	}
	/* 合计 */
	.totalDetail{
		background: #FFFFFF;
		padding: .3rem;
		border-radius: .24rem;
	}
	.totalDetail>p{
		color: red;
	}
	.DownloadChapterWrap .total{
		width: 100%;
	}
	.total .text{
		font-size: 14px;
		color: #A6A5AB;
		letter-spacing: 0.6px;
		margin: .26rem 0 .1rem;
	}
	.total .Price{
		font-size: 14px;
		color: #CE5857;
		letter-spacing: 0.69px;
	}
	.total .Price>span:nth-child(2){
		font-size: 20px;
		letter-spacing: 1.54px;
	}
	.total .Price>span:nth-child(3){
		color: #424242;
		margin-left: 5px;
	}
	/* 购买详情 */
	.DownloadChapterWrap ul,.allbook{
		width: 100%;
	}
	.nodeWrap{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: .1rem 0;
	}
	.nodeWrap span{
		font-size: 15px;
		color: #424242;
		letter-spacing: 0.51px;
	}
	.nodeWrap .nodeText{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	/* 全书购买 */
	.allbook{
		display: flex;
		padding: 15px 20px;
	}
	.allbook img{
		width: 1.22rem;
		height: 1.62rem;
		margin-right: .2rem;
	}
	.allbook .bookInfo h4{
		font-size: .3rem;
		color: #424242;
		letter-spacing: 0;
		line-height: .36rem;
		margin: .05rem 0 .2rem;
	}
	.allbook .bookInfo p{
		font-size: .24rem;
		color: #919095;
		letter-spacing: 0;
		line-height: .24rem;
		margin-bottom: .07rem;
	}
	.allbook .bookInfo span{
		font-size: 13px;
		color: #424242;
		letter-spacing: .69px;
	}
	/* 支付方式 */
	.AilpayWayWrap{
		padding: .3rem;
		background-color: #FFFFFF;
		border-radius: .24rem;
	}
	.AilpayWayWrap .Ailpay,.AilpayWayWrap .wechat{
		width: 100%;
		border-radius: 8px;
		border: 2px solid transparent;
		background: #F7F8FA;
	}
	.AilpayWayWrap .wechat{
		margin-top: 20px;
	}
	.AilpayWayWrap .SelectLight{
		border: 2px solid #2468F2;
		background: #FFFFFF;
	}
	.AilpayWayWrap label{
		line-height: 60px;
		padding: 0 20px;
		display: flex;
		align-items: center;
		flex-direction: row-reverse;
		justify-content: space-between;
	}
	/* 确认支付 */
	.confirmBtn {
		border-radius: 6px;
		line-height: 50px;
		font-size: 16px;
		color: #FFFFFF;
		letter-spacing: 0.69px;
		text-align: center;
		margin: 30px 0 20px;
	}
	.canConfirmBtn{
		background: #2468F2;
		cursor: pointer;
	}
	.notConfirmBtn {
		background: #dcdfe6;
	}
	/* 关闭 */
	.DownloadChapterWrap>span{
		display: none;
	}
}
@media screen and (min-width: 1445px) {
	/* 订单信息弹窗 */
	.DownloadChapterCover{
		width: 100%;
		height: 100%;
		text-align: left;
		background: rgba(0,0,0,0.40);
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
	}
	.DownloadChapterWrap{
		width: 520px;
		box-sizing: border-box;
		padding: 0 20px;
		background: #F7F8FA;
		background-image: linear-gradient(180deg, #BFE3FF 0%, rgba(231,245,255,0.00) 15%);
		border-radius: 8px;
		position: relative;
	}
	.DownloadChapterWrap h2{
		line-height: 60px;
		text-align: center;
		font-size: 14px;
		color: #333333;
	}
	.DownloadChapterWrap h3{
		font-size: 14px;
		color: #919095;
		letter-spacing: 0.6px;
		line-height: 14px;
		margin: 20px 0 12px;
	}
	.totalDetail>p{
		color: red;
		margin: 10px 0;
	}
	/* 合计 */
	.DownloadChapterWrap .total{
		width: 100%;
		padding: 30px;
		background: #FFFFFF;
		border-radius: 12px;
		margin-top: 20px;
	}
	.total .text{
		font-size: 14px;
		color: #A6A5AB;
		letter-spacing: 0.6px;
		line-height: 14px;
		margin-bottom: 12px;
	}
	.total .Price{
		font-size: 14px;
		color: #CE5857;
		letter-spacing: 0.69px;
	}
	.total .Price>span:nth-child(2){
		font-size: 20px;
		letter-spacing: 1.54px;
	}
	.total .Price>span:nth-child(3){
		color: #424242;
		margin-left: 5px;
	}
	/* 购买详情 */
	.DownloadChapterWrap ul,.allbook{
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		border-radius: 4px;
	}
	.nodeWrap{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 10px 0;
	}
	.nodeWrap span{
		font-size: 18px;
		color: #424242;
		letter-spacing: 0.51px;
	}
	.nodeWrap .nodeText{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	/* 全书购买 */
	.allbook{
		display: flex;
		padding: 15px 20px;
	}
	.allbook img{
		width: 87px;
		height: 116px;
		margin-right: 13px;
	}
	.allbook .bookInfo h4{
		font-size: 17px;
		color: #424242;
		letter-spacing: 0;
		line-height: 25px;
	}
	.allbook .bookInfo p{
		font-size: 14px;
		color: #919095;
		letter-spacing: 0;
		line-height: 14px;
		margin: 10px 0 7px;
	}
	.allbook .bookInfo span{
		font-size: 13px;
		color: #424242;
		letter-spacing: 0.69px;
	}
	/* 支付方式 */
	.AilpayWayWrap{
		padding: 20px;
		background-color: #FFFFFF;
		border-radius: 12px;
	}
	.AilpayWayWrap .Ailpay,.AilpayWayWrap .wechat{
		width: 100%;
		border-radius: 8px;
		border: 2px solid transparent;
		background: #F7F8FA;
	}
	.AilpayWayWrap .wechat{
		margin-top: 20px;
	}
	.AilpayWayWrap .SelectLight{
		border: 2px solid #2468F2;
		background: #FFFFFF;
	}
	.AilpayWayWrap label{
		line-height: 60px;
		padding: 0 20px;
		display: flex;
		align-items: center;
		flex-direction: row-reverse;
		justify-content: space-between;
	}
	/* 确认支付 */
	.confirmBtn{
		border-radius: 6px;
		line-height: 50px;
		font-size: 16px;
		color: #FFFFFF;
		letter-spacing: 0.69px;
		text-align: center;
		margin: 30px 0 20px;
	}
	.canConfirmBtn{
		background: #2468F2;
		cursor: pointer;
	}
	.notConfirmBtn {
		background: #dcdfe6;
	}
	/* 关闭 */
	.DownloadChapterWrap>span{
		position: absolute;
		top: 15px;
		right: 20px;
		display: block;
		width: 30px;
		height: 30px;
		background: url(../assets/img/detailsClose_icon.svg) no-repeat;
		cursor: pointer;
	}
}
@media screen and (min-width: 1029px) and (max-width: 1444px) {
	.topPart{
		display: none;
	}
	/* 订单信息弹窗 */
	.DownloadChapterCover{
		width: 100%;
		height: 100%;
		text-align: left;
		background: rgba(0,0,0,0.40);
		display: flex;
		align-items: center;
		justify-content: center;
		position: fixed;
		top: 0;
		left: 0;
		z-index: 9999;
	}
	.DownloadChapterWrap{
		width: 520px;
		box-sizing: border-box;
		padding: 0 20px;
		background: #F7F8FA;
		background-image: linear-gradient(180deg, #BFE3FF 0%, rgba(231,245,255,0.00) 15%);
		border-radius: 8px;
		position: relative;
	}
	.DownloadChapterWrap h2{
		line-height: 45px;
		text-align: center;
		font-size: 14px;
		color: #333333;
	}
	.DownloadChapterWrap h3{
		font-size: 14px;
		color: #919095;
		letter-spacing: 0.6px;
		line-height: 14px;
		margin: 15px 0 12px;
	}
	.totalDetail>p{
		color: red;
		margin: 5px 0;
	}
	/* 合计 */
	.DownloadChapterWrap .total{
		width: 100%;
		padding: 20px;
		background: #FFFFFF;
		border-radius: 12px;
		margin-top: 10px;
	}
	.total .text{
		font-size: 14px;
		color: #A6A5AB;
		letter-spacing: 0.6px;
		line-height: 14px;
		margin-bottom: 12px;
	}
	.total .Price{
		font-size: 14px;
		color: #CE5857;
		letter-spacing: 0.69px;
	}
	.total .Price>span:nth-child(2){
		font-size: 20px;
		letter-spacing: 1.54px;
	}
	.total .Price>span:nth-child(3){
		color: #424242;
		margin-left: 5px;
	}
	/* 购买详情 */
	.DownloadChapterWrap ul,.allbook{
		width: 100%;
		padding: 0 20px;
		box-sizing: border-box;
		background-color: #FFFFFF;
		border-radius: 4px;
	}
	.nodeWrap{
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 5px 0;
	}
	.nodeWrap span{
		font-size: 18px;
		color: #424242;
		letter-spacing: 0.51px;
	}
	.nodeWrap .nodeText{
		overflow: hidden;
		text-overflow:ellipsis;
		white-space: nowrap;
	}
	/* 全书购买 */
	.allbook{
		display: flex;
		padding: 15px 20px;
	}
	.allbook img{
		width: 87px;
		height: 116px;
		margin-right: 13px;
	}
	.allbook .bookInfo h4{
		font-size: 17px;
		color: #424242;
		letter-spacing: 0;
		line-height: 25px;
	}
	.allbook .bookInfo p{
		font-size: 14px;
		color: #919095;
		letter-spacing: 0;
		line-height: 14px;
		margin: 10px 0 7px;
	}
	.allbook .bookInfo span{
		font-size: 14px;
		color: #424242;
		letter-spacing: 0.69px;
	}
	/* 支付方式 */
	.AilpayWayWrap{
		padding: 10px;
		background-color: #FFFFFF;
		border-radius: 12px;
	}
	.AilpayWayWrap .Ailpay,.AilpayWayWrap .wechat{
		width: 100%;
		border-radius: 8px;
		border: 2px solid transparent;
		background: #F7F8FA;
	}
	.AilpayWayWrap .wechat{
		margin-top: 20px;
	}
	.AilpayWayWrap .SelectLight{
		border: 2px solid #2468F2;
		background: #FFFFFF;
	}
	.AilpayWayWrap label{
		line-height: 50px;
		padding: 0 20px;
		display: flex;
		align-items: center;
		flex-direction: row-reverse;
		justify-content: space-between;
	}
	/* 确认支付 */
	.confirmBtn{
		border-radius: 6px;
		line-height: 40px;
		font-size: 16px;
		color: #FFFFFF;
		letter-spacing: 0.69px;
		text-align: center;
		margin: 20px 0 20px;
	}
	.canConfirmBtn{
		background: #2468F2;
		cursor: pointer;
	}
	.notConfirmBtn {
		background: #dcdfe6;
	}
	/* 关闭 */
	.DownloadChapterWrap>span{
		position: absolute;
		top: 7px;
		right: 17px;
		display: block;
		width: 25px;
		height: 25px;
		background: url(../assets/img/detailsClose_icon.svg) no-repeat;
		background-size: 100%;
		cursor: pointer;
	}
}
</style>



// WEBPACK FOOTER //
// src/components/DownloadChapter.vue